import { OrganizationCountry } from "../enums/country";
// Pre-ticking relies on implied consent (US, CA, AU, NZ); only Germany forbids emailing without an opt-in.
export const COMMUNICATION_CONSENT_BY_COUNTRY = {
    [OrganizationCountry.UnitedStates]: { canPreselect: true, canEmailWithoutOptIn: true },
    [OrganizationCountry.Canada]: { canPreselect: true, canEmailWithoutOptIn: true },
    [OrganizationCountry.GreatBritain]: { canPreselect: false, canEmailWithoutOptIn: true },
    [OrganizationCountry.Australia]: { canPreselect: true, canEmailWithoutOptIn: true },
    [OrganizationCountry.NewZealand]: { canPreselect: true, canEmailWithoutOptIn: true },
    [OrganizationCountry.Ireland]: { canPreselect: false, canEmailWithoutOptIn: true },
    [OrganizationCountry.Germany]: { canPreselect: false, canEmailWithoutOptIn: false },
};
export const areCommunicationPreferencesPreselected = (country) => Boolean(country && COMMUNICATION_CONSENT_BY_COUNTRY[country].canPreselect);
export const canEmailContactWithoutOptIn = (country) => COMMUNICATION_CONSENT_BY_COUNTRY[country].canEmailWithoutOptIn;
